import React from 'react';

export const AccountsList = React.lazy(() => import('./AccountsList'));
export const AccountDetails = React.lazy(() => import('./AccountDetails'));
export const AccountForm = React.lazy(() => import('./AccountForm'));
